import React from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { WhatsAppCTA } from "../WhatsAppCTA";
import { CONTACT } from "../../lib/site";
import { fadeUp, staggerContainer, viewport } from "../../lib/motion";

const STATS = [
  { value: "10", label: "Anos de mercado" },
  { value: "5k+", label: "Clientes atendidos" },
];

export const Trust = () => {
  return (
    <section
      data-testid="trust-section"
      className="relative bg-[#050505] py-28 md:py-40"
    >
      <div className="absolute inset-0 spotlight pointer-events-none" />
      <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="visible"
        viewport={viewport}
        className="relative w-full max-w-4xl mx-auto px-6 md:px-12 text-center"
      >
        <motion.span
          variants={fadeUp}
          className="text-xs font-semibold uppercase tracking-[0.25em] text-[#86868b]"
        >
          Desde 2016
        </motion.span>

        <motion.h2
          variants={fadeUp}
          className="mt-6 text-4xl md:text-6xl font-bold tracking-tighter leading-[1.02] text-[#f5f5f7]"
        >
          <span className="block">Cuidando do seu celular</span>
          <span className="block">com quem entende.</span>
        </motion.h2>

        {/* Rating */}
        <motion.a
          variants={fadeUp}
          href={CONTACT.googleReview}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="trust-google-review"
          className="mt-8 inline-flex items-center gap-3 group"
        >
          <span className="flex items-center gap-1">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star
                key={i}
                size={20}
                className="fill-[#f59e0b] text-[#f59e0b]"
              />
            ))}
          </span>
          <span className="text-[#f5f5f7] text-lg group-hover:underline underline-offset-4">
            4.9 no Google
          </span>
        </motion.a>

        {/* Stats */}
        <motion.div
          variants={fadeUp}
          className="mt-14 grid grid-cols-2 gap-8 max-w-md mx-auto"
        >
          {STATS.map((stat, i) => (
            <div key={i} data-testid={`trust-stat-${i + 1}`}>
              <div className="text-5xl md:text-6xl font-bold tracking-tighter text-[#f5f5f7]">
                {stat.value}
              </div>
              <div className="mt-2 text-sm text-[#86868b]">{stat.label}</div>
            </div>
          ))}
        </motion.div>

        <motion.div variants={fadeUp} className="mt-14 flex justify-center">
          <WhatsAppCTA label="Falar no WhatsApp" testId="trust-whatsapp" />
        </motion.div>
      </motion.div>
    </section>
  );
};
